document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('video');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.6 });

  videos.forEach(video => {
    observer.observe(video);
  });
});
